import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { NavigationItem, StackLayout } from "@salt-ds/core";
import { pagePath } from "src/app/Routers";
import store from "src/store/store";
import { setActiveTab } from "src/reducers/slices/SetActiveTabSlice";
import { FAQS, PAYMENTTERM } from "../utils/Constants";
import { setAccordionStateDetails } from "src/reducers/slices/FaqAccordionSlice";
import { usePaymentTermsLogic } from "src/selectors/UsePaymentTermsLogic";

const Tabs = () => {
  const selectedTab = useSelector(
    (state: ReturnType<typeof store.getState>) => state.setActiveTab.value,
  );

  const { isPaymentTabVisible } = usePaymentTermsLogic();

  const navItems = isPaymentTabVisible
    ? ["Product Overview", PAYMENTTERM, FAQS]
    : ["Product Overview", FAQS];
  const [active, setActive] = React.useState(navItems[0]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    switch (selectedTab.activeTab) {
      case "Product Overview":
        setActive("Product Overview");
        return navigate("/");
      case PAYMENTTERM:
        setActive(PAYMENTTERM);
        return navigate(pagePath.paymentTerm);
      case FAQS:
        setActive(FAQS);
        return navigate(pagePath.faq);
      default:
        break;
    }
  }, [selectedTab.activeTab]);

  return (
    <>
      <div>
        <nav>
          <StackLayout
            as="ul"
            direction="row"
            gap={1}
            className=" mt-5 font-semibold text-sm/18 text-[#61656E] "
          >
            {navItems.map((item) => {
              return (
                <li key={item}>
                  <NavigationItem
                    active={active === item}
                    href="javascript:void(0)"
                    //href= {navPath}
                    onClick={() => {
                      window.scroll(0, 0);
                      setActive(item);
                      dispatch(setActiveTab(item));
                      dispatch(setAccordionStateDetails(""));
                    }}
                  >
                    {item}
                  </NavigationItem>
                </li>
              );
            })}
          </StackLayout>
        </nav>
      </div>
    </>
  );
};

export default Tabs;
